module.exports = __webpack_public_path__ + "img/img7.6ecc7ee5.png";